import styled from 'styled-components';

import { createSingleInterpolatedTranslationKey, FormContextValues } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../../translations';

import { RecurrencePeriodUnit } from './RecurrencePeriodUnitField';

const RECURRENCE_PERIOD_FIELD_NAME = 'recurrencePeriod';

const StyledSelect = styled(Select)`
   max-width: 69px;
` as typeof Select;

export type RecurrencePeriodType = number;

type RecurrencePeriodFormBeanPart = { [RECURRENCE_PERIOD_FIELD_NAME]?: RecurrencePeriodType };
type RecurrencePeriodFieldProps = Pick<FormContextValues<RecurrencePeriodFormBeanPart>, 'register'> & {
   readonly recurrenceUnit?: RecurrencePeriodUnit;
};

export const getPeriodListValues = (recurrenceUnit: RecurrencePeriodUnit = 'WEEKS'): number[] => {
   const ARRAY_LENGTH_FOR = { DAYS: 60, WEEKS: 12, MONTHS: 12 };
   return Array.from({ length: ARRAY_LENGTH_FOR[recurrenceUnit] }, (__, i) => i + 1);
};

export const RecurrencePeriodField = (props: RecurrencePeriodFieldProps): JSX.Element => {
   return (
      <StyledSelect
         triggerLabelExtractor={String}
         controller={props.register(RECURRENCE_PERIOD_FIELD_NAME)}
         testId={RECURRENCE_PERIOD_FIELD_NAME}
         label={appointmentsTranslationKeys.create.form.recurrencePeriod}
         defaultValue={1}
      >
         <Select.List items={getPeriodListValues(props.recurrenceUnit)}>
            {(periodValue) => (
               <Select.Item
                  testId={periodValue}
                  item={periodValue}
                  label={createSingleInterpolatedTranslationKey(
                     appointmentsTranslationKeys.create.form.recurrencePeriodValue,
                     'periodValue',
                     periodValue
                  )}
               />
            )}
         </Select.List>
      </StyledSelect>
   );
};
